export default {
  data() {
    return {
      searchDrug: '',
      searchNotSelected: '',
      //row 1
      totalReports: '',
      ambulanceReports: '',
      motorAmbulanceReports: '',
      activeCodes: '',
      reserveCodes: '',
      //row 2
      dashboardIMG: require('@/assets/images/dashboard800Image2.png'),
      fuelEmpty: null,
      isFilterModalOpen: false,
      fuelHalf: null,
      fuelFull: null,
      threeQuarter: null,
      fuelQuarter: null,
      //row 3
      drugShortageCountTableHeader: [
        {
          text: 'گروه دارو',
          value: 'drugGroup',
          align: 'center',
          isGroupable: true,
        },
        {
          text: 'نام دارو',
          value: 'drugName',
          align: 'center',
          isGroupable: true,
        },
        { text: 'تعداد فرم ها', value: 'count', align: 'center' },
        { text: 'عملیات', value: 'actions', align: 'center' },
      ],
      drugShortageCountTableItems: [],
      notSelectedItemsCountTableHeader: [
        { text: 'عنوان', value: 'title', align: 'start' },
        { text: 'تعداد فرم ها', value: 'count', align: 'center' },
        { text: 'عملیات', value: 'actions', align: 'center' },
      ],
      notSelectedItemsCountTableItems: [],
      filterFields: {
        fromDate: '',
        toDate: '',
      },
      filters: {
        fromDate: null,
        toDate: null,
      },
      isDrugShortageFilterModalOpen: false,
      drugShortageFilterFields: {
        fromDate: null,
        toDate: null,
      },
    };
  },
  computed: {
    hasAnyDrugShortageFilter: function () {
      return this.drugShortageFilterFields?.fromDate || this.drugShortageFilterFields?.toDate;
    },
  },
  methods: {
    readyDashboard: function (data) {
      this.totalReports = data.totalReports ? data.totalReports.valueLong : '-';
      this.ambulanceReports = data.ambulanceReports ? data.ambulanceReports.valueLong : '-';
      this.motorAmbulanceReports = data.motorAmbulanceReports
        ? data.motorAmbulanceReports.valueLong
        : '-';
      this.activeCodes = data.activeCodes ? data.activeCodes.valueLong : '-';
      this.reserveCodes = data.reserveCodes ? data.reserveCodes.valueLong : '-';
      //row2
      this.fuelEmpty = data.fuelEmpty ? data.fuelEmpty.valueLong : '-';
      this.fuelHalf = data.fuelHalf ? data.fuelHalf.valueLong : '-';
      this.fuelQuarter = data.fuelQuarter ? data.fuelQuarter.valueLong : '-';
      this.fuelFull = data.fuelFull ? data.fuelFull.valueLong : '-';
      this.threeQuarter = data.threeQuarter ? data.threeQuarter.valueLong : '-';
    },
    readyDrugShortageCountData: function (data) {
      this.drugShortageCountTableItems = [];
      for (let i = 0; i < data.length; i++) {
        this.drugShortageCountTableItems.push({
          drugGroup: data[i].drugGroupTitle ? data[i].drugGroupTitle : '-',
          drugName: data[i].drugTitle ? data[i].drugTitle : '-',
          count: data[i].count ? data[i].count : '-',
          id: data[i].drugId,
        });
      }
    },
    readyNotSelectedItemsCountData: function (data) {
      this.notSelectedItemsCountTableItems = [];
      for (let i = 0; i < data.length; i++) {
        this.notSelectedItemsCountTableItems.push({
          title: data[i].title ? data[i].title : '-',
          count: data[i].count ? data[i].count : '-',
          id: data[i].checkListCategoryItemId,
        });
      }
    },
    goToAllCheckLists: function () {
      this.$router.push({ name: 'qcAllCheckLists' });
    },
    goToAllCheckListsFromDrug: function (id) {
      let rouet = '1_' + id;
      this.$router.push({ name: 'qcAllCheckLists', params: { id: rouet } });
    },
    goToAllCheckListsFromNotSelectd: function (id) {
      let rouet = '2_' + id;
      this.$router.push({ name: 'qcAllCheckLists', params: { id: rouet } });
    },
    openFilterModal: function () {
      this.isFilterModalOpen = true;
    },
    closeFilterModal: function () {
      this.isFilterModalOpen = false;
    },
    onSearch: function () {
      const nowDate = this.getLocalISODateString(new Date());
      const startTime = `${nowDate?.split('T')[0]}T00:00:00`;
      const nowTime = nowDate;
      this.filters = {
        fromDate: this.filterFields.fromDate ? this.filterFields.fromDate : startTime,
        toDate: this.filterFields.toDate ? this.filterFields.toDate : nowTime,
      };
    },
    initialFilter: function () {
      this.onSearch();
    },
    openDrugShortagesFilterModal: function () {
      this.isDrugShortageFilterModalOpen = true;
    },
    closeDrugShortagesFilterModal: function () {
      this.isDrugShortageFilterModalOpen = false;
    },
    searchDrugShortage: function (filterField) {
      this.drugShortageFilterFields = filterField;
      this.getDrugShortageCountFunction(this.drugShortageFilterFields);
      this.closeDrugShortagesFilterModal();
    },
    removeDrugShortageFilter: function () {
      this.drugShortageFilterFields.toDate = null;
      this.drugShortageFilterFields.fromDate = null;
      this.getDrugShortageCountFunction(this.drugShortageFilterFields);
    },
  },
};
